const CORINNE = "corinne.golfier@fautras.com";
const dateFR = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "");
const num = (v) => (v == null || v === "" ? "" : String(Math.round(Number(v) * 100) / 100).replace(".", ","));
const cell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
const FIN = { ok: "Financement OK", study: "Financement en étude", none: "Pas de financement" };

// Spreadsheet (CSV ; UTF-8 BOM, opens directly in Excel) of orders with Divalto references.
export function exportOrdersCsv(quotes, name = "commandes") {
  const head = ["N° commande", "Date devis", "Signée le", "Vendeur", "Responsable du secteur", "Client", "Code postal", "Ville", "Pays", "Modèle", "Total TTC (€)",
    "Code client Divalto", "Numéro cde Divalto", "Réf cde revendeur", "Acompte reçu", "Financement", "Secteur", "Bon papier", "Transmise à Corinne", "Traitée par l'ADV"];
  const rows = quotes.map((x) => {
    const c = x.client || {};
    const client = [c.name, c.firstname].filter(Boolean).join(" ") || c.company || "";
    const corinne = !!x.corinne_sent || (x.send_log || []).some((l) => (l.to || []).includes(CORINNE));
    return [x.quote_number, dateFR(x.created_at), dateFR(x.signed_at), x.reseller_name, (x.sector_owners || []).join(", "), client, c.postal, c.city, c.country || x.country_code,
      x.model_name, num(x.total_public_ttc), x.client_divalto_code, x.divalto_order, x.reseller_ref,
      x.stock_order ? "" : x.deposit_received ? "Oui" : "Non", x.stock_order ? "" : FIN[x.financing_choice] || "",
      x.stock_order ? "" : x.out_of_sector ? "Hors secteur" : "Secteur", x.paper_order ? "Oui" : "", corinne ? "Oui" : "Non", (x.client_divalto_code || "").trim() && (x.divalto_order || "").trim() ? "Oui" : "Non"];
  });
  const csv = "\ufeff" + [head, ...rows].map((r) => r.map(cell).join(";")).join("\r\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  a.download = `${name}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}
